import React from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HandshakeIcon from '@mui/icons-material/Handshake';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
//import NotificationsIcon from '@material-ui/icons/Notifications';
import LogoutIcon from '@mui/icons-material/Logout';
import AppsIcon from '@mui/icons-material/Apps';
import SwipeableTopDrawer from "../components/SwipeableTopDrawer";
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';


const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1, 
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default function Header(props) {
  const userObj = useSelector(state => state.userDetails);
  const classes = useStyles();
  const [expireAlert, setExpireAlert] = React.useState(false);
  const [expireAlertMsg, setExpireAlertMsg] = React.useState("");

  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const isMenuOpen = Boolean(anchorEl);
  // const handleProfileMenuOpen = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleMenuClose = () => {
  //   setAnchorEl(null);
  //   handleMobileMenuClose();
  // };

// *******************************************************************

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  // *******************************************************************

  // const menuId = 'primary-search-account-menu';
  // const renderMenu = (
  //   <Menu
  //     anchorEl={anchorEl}
  //     anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
  //     id={menuId}
  //     keepMounted
  //     transformOrigin={{ vertical: 'top', horizontal: 'right' }}
  //     open={isMenuOpen}
  //     onClose={handleMenuClose}
  //   >
  //     <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
  //     <MenuItem onClick={handleMenuClose}>My Orders</MenuItem>
  //   </Menu>
  // );

  // const menuCourseId = 'primary-search-course-menu';
  // const courseMenu = (
  //   <Menu
  //     anchorEl={anchorEl}
  //     anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
  //     id={menuCourseId}
  //     keepMounted
  //     transformOrigin={{ vertical: 'top', horizontal: 'right' }}
  //     open={isMenuOpen}
  //     onClose={handleMenuClose}
  //   >
  //     <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
  //     <MenuItem onClick={handleMenuClose}>My Orders</MenuItem>
  //   </Menu>
  // );

  function goLocation(val) {
    window.location=val;
  }

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={()=>{goLocation('/subscription/cases')}} >
        <IconButton color="inherit" >
          <SupportAgentIcon />
        </IconButton>
        <p>Service Cases</p>
      </MenuItem>
      <MenuItem onClick={()=>{goLocation('/order/orders')}} >
        <IconButton color="inherit" >
          <ShoppingCartIcon />
        </IconButton>
        <p>Orders</p>
      </MenuItem>
      <MenuItem onClick={()=>{goLocation('/tender/tenders')}} >
        <IconButton color="inherit" >
          <HandshakeIcon />
        </IconButton>
        <p>Tenders</p>
      </MenuItem>
    </Menu>
  );

  React.useEffect(() => {		
		if(userObj && userObj.expireDate && userObj.expireDate.length>0){
      checkExpire();	
		}
	}, [userObj]);

  function logout(){
    Cookies.remove('isrwadminloggedin');
    window.location.href='login';
  }

  function checkExpire() {
    if(userObj.expireDate && userObj.deactivateDate){
      let cdate = new Date();   
      let exdate = new Date(userObj.expireDate);
      let diffExDate = exdate.getTime() - cdate.getTime();
      let daydiffExDate = (diffExDate / (1000 * 60 * 60 * 24))+1;
      ///************************************* */
      let dedate = new Date(userObj.deactivateDate);  
      let diffDeDate = dedate.getTime() - cdate.getTime();
      let daydiffDeDate = (diffDeDate / (1000 * 60 * 60 * 24));
      // alert("daydiffExDate: "+daydiffExDate);
      // alert("daydiffDeDate: "+daydiffDeDate); 		
      if(daydiffExDate>0 && daydiffExDate<daydiffDeDate && daydiffExDate<16){
        setExpireAlert(true);
        let dtArr = userObj.expireDate.split('-');
        setExpireAlertMsg("Reminder: BizOfficer subscription is going to expire on "+dtArr[2]+"-"+dtArr[1]+"-"+dtArr[0]+". Kindly do payment to avoid service interruption.");
      }else if(daydiffExDate<0 && daydiffDeDate>0){
        setExpireAlert(true);
        let xdtArr = userObj.expireDate.split('-');
        let dedtArr = userObj.deactivateDate.split('-');
        setExpireAlertMsg("Reminder: BizOfficer subscription has been expired on "+xdtArr[2]+"-"+xdtArr[1]+"-"+xdtArr[0]+". Kindly do payment to avoid service interruption before "+dedtArr[2]+"-"+dedtArr[1]+"-"+dedtArr[0]);
      }else if(daydiffDeDate<0){
        logout();
      }    
    }
  }

  return (<>
    {!window.navigator.onLine?<div className='netBar' >Alert: It seems, you are not connected to the internet.</div>:null}
    {expireAlert?<div className='netBar' >{expireAlertMsg}</div>:null}
    <div className={classes.grow}>
      <AppBar position="static">
        <Toolbar variant="dense" >

          {props.hamburger?<SwipeableTopDrawer/>:null}  
 
          <div style={{marginTop:7}} >
            <img alt="logo" src={process.env.PUBLIC_URL+"/icon-logo.png"} /> 
          </div>

          <div style={{marginLeft: 15, fontSize: 16}}>
            {props.pageTitle}
          </div>
          
          <div className={classes.grow} />

            <IconButton onClick={handleMobileMenuOpen} aria-label="courses" color="inherit">              
                <AppsIcon />              
            </IconButton>
            <IconButton onClick={()=>{logout()}} aria-label="courses" color="inherit">              
                <LogoutIcon />              
            </IconButton>


        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {/* {renderMenu}       */}
    </div>
  </>);
}